// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import store from './store/index'
import router from './router'
import axios from './global/axios'
import auth from './global/auth'
import common from './global/common'
import Configure from './global/configure'
import cnLang from './global/cnLang'
import enLang from './global/enLang'
import 'element-ui/lib/theme-chalk/index.css'
import ElementUI from 'element-ui'
import NProgress from 'nprogress'
import 'nprogress/nprogress.css'
import 'babel-polyfill'
import App from './App'
import { queryStuMenuList, getSaasCompanyInfoByDomain, addRecord } from './api/public/public'
import enLocale from 'element-ui/lib/locale/lang/en'
// 自定义弹窗组件
import MyPopup from './components/Public/MyPopup.vue'
import NoData from './components/Public/NoData.vue'
import themeItem from './utils/theme_configure/theme.color.js'
import './utils/quill/index.js'
// 配置图片预览插件
import Viewer from 'v-viewer'
import 'viewerjs/dist/viewer.css'
// 配置全局指令
import directive from './directive/index.js'
import globalMethod from './global/method'
import showUnreaMsgdNotify from './global/showUnreaMsgNotify.js'
import showMessage from './utils/message.js'

// 注入所有全局方法
globalMethod(Vue)
// 注册所有全局指令
directive(Vue)
// 注册图片预览插件
Vue.use(Viewer)
Viewer.setDefaults({
  // 需要配置的属性 注意属性并没有引号
  title: false,
  toolbar: true
})
// 将二级域名保存为全局变量
Vue.prototype.$domainName = location.hostname.split('.')[0]
// Vue.prototype.$domainName = '6c' // 测试用

Vue.prototype.$themeItem = themeItem

Vue.config.productionTip = false
// 定义全局变量
global.$sider = ''
// 引用公共方法
Vue.prototype.$common = common
// 引用axios插件
Vue.prototype.$http = axios
// 引用配置
Vue.prototype.$config = Configure
// 是否青豆站点
let benzhan = window.location.hostname.split('.')[0]
if (benzhan === 'localhost' || benzhan === '10' || benzhan === 'dev' || benzhan === 'uat' || benzhan === 'chindle') {
  Vue.prototype.$isQd = 1
} else {
  Vue.prototype.$isQd = 2
}

Vue.component('MyPopup', MyPopup)
Vue.component('NoData', NoData)
window.addEventListener('beforeunload', function () {
  // 页面卸载前 清空
  common.setCookie('isVisit', '')
}, false)
// 路由的判断
router.beforeEach((to, from, next) => {
  to.meta && to.meta.parent && showUnreaMsgdNotify()
  if (to.path) {
    window._hmt.push(['_trackPageview', to.fullPath])
  }
  var userAgentInfo = navigator.userAgent
  var Agents = ['Android', 'iPhone', 'SymbianOS', 'Windows Phone', 'iPad', 'iPod']
  var flag = true
  for (var v = 0; v < Agents.length; v++) {
    if (userAgentInfo.indexOf(Agents[v]) > 0) {
      flag = false
      break
    }
  }
  let hrefList = (window.location.href).split('/web/')
  if (!flag && (to.name !== 'Groupon' && to.name !== 'GrouponOrder' && to.name !== 'Extension')) {
    if (to.name === 'InviteFriends') {
      window.location.href = location.origin + '/mobile/receive/index'
    } else if (to.name === 'AssessEvaluation') {
      window.location.href = location.origin + '/mobile/item/transition?bid=' + to.query.bid
    } else {
      if (location.href.indexOf('/web/') > -1) {
        window.location.href = location.origin + '/mobile/' + hrefList[1]
      } else {
        window.location.href = location.href + 'mobile/index'
      }
    }
  } else {
    NProgress.start() // 开启Progress
    let siteName
    if (process.env.NODE_ENV === 'dev') {
      siteName = Configure.site_name
    } else {
      siteName = window.location.hostname.split('.')[0]
    }
    let companydata = {
      secondLevelDomain: siteName
    }
    // 是否需要验证
    if (!to.matched.some(m => m.meta.auth)) {
      // 判断是否登录
      let userData = common.getUserInfo()
      let token = common.getCookie('qd_access_token')
      let talkUserType = common.getCookie('qd_person_info')
      let personImg = common.getCookie('qd_person_img')
      let mName = common.getName()
      store.state.Auth.sign = !!token
      store.state.Auth.token = token
      store.state.Auth.isFirstLogin = userData.firstLogin
      store.state.Auth.name = mName
      store.state.Auth.userImg = personImg
      store.state.Auth.userType = userData.userType
      store.state.Auth.talkUser = talkUserType
      store.state.Auth.branchName = userData.branchName
      let locale = localStorage.getItem(Configure.cookie_prefix + 'locale')
      if (!locale || locale === 'cn') {
        Vue.use(ElementUI)
        // 将封装的消息通知方法挂载到 Vue 的原型上
        Vue.prototype.$lang = cnLang
      } else if (locale === 'en') {
        Vue.use(ElementUI, { locale: enLocale })
        Vue.prototype.$lang = enLang
      }
      Vue.prototype.$message = showMessage
      if (to.meta && to.meta.noGetSaasInfo) {
        // noGetSaasInfo为true 不调用接口获取机构信息
        let companyData = JSON.parse(localStorage.getItem('companyData'))
        if (companyData) {
          document.title = companyData.chindleShortName
          let link = document.querySelector('link[rel*="icon"]') || document.createElement('link')
          link.type = 'image/x-icon'
          link.rel = 'shortcut icon'
          link.href = companyData.logoBrowser
          document.getElementsByTagName('head')[0].appendChild(link)
        }
        next()
      } else if (store.state.Auth.sign) {
        getSaasCompanyInfoByDomain(companydata).then((info) => {
          if (info.data.resultCode === 0) {
            localStorage.setItem('companyData', JSON.stringify(info.data.resultData))
            store.state.Auth.companyId = info.data.resultData.companyId
            store.commit('changeCompanyInfo', info.data.resultData)
            let params = {
              platformType: 0
            }
            if (common.getCookie('isVisit') !== 'true') {
              addRecord(params).then(res => {
                if (res.data.resultCode === 0) {
                  common.setCookie('isVisit', 'true')
                }
              })
            }
            document.title = info.data.resultData.chindleShortName
            let link = document.querySelector('link[rel*="icon"]') || document.createElement('link')
            link.type = 'image/x-icon'
            link.rel = 'shortcut icon'
            link.href = info.data.resultData.logoBrowser
            document.getElementsByTagName('head')[0].appendChild(link)
          }
        })
        if (store.state.Auth.userType === 3) {
          store.state.Auth.menuList = JSON.parse(localStorage.getItem('menu'))
          if (!store.state.Auth.menuList) {
            queryStuMenuList().then((info) => {
              if (info.data.resultCode === 0) {
                store.state.Auth.menuList = info.data.resultData
                localStorage.setItem('menu', JSON.stringify(info.data.resultData))
                if (info.data.resultData[0]) {
                  info.data.resultData[0].menuList.forEach(item => {
                    if (item.router === to.name) {
                      global.$sider = item.id
                    }
                  })
                }
              }
              next()
            })
          } else {
            if (store.state.Auth.menuList[0]) {
              store.state.Auth.menuList[0].menuList.forEach(item => {
                if (item.router === to.name) {
                  global.$sider = item.id
                }
              })
            }
            next()
          }
        } else {
          if (to.name === 'CodeLogin' || to.name === 'Login') {
            next()
          } else {
            router.push({name: 'Login'})
          }
          // store.dispatch('logout').then(() => {
          //   // 重定向到登录页面
          //   next()
          // })
        }
      } else {
        getSaasCompanyInfoByDomain(companydata).then((info) => {
          if (info.data.resultCode === 0) {
            localStorage.setItem('companyData', JSON.stringify(info.data.resultData))
            store.state.Auth.companyId = info.data.resultData.companyId
            store.commit('changeCompanyInfo', info.data.resultData)
            let params = {
              platformType: 0
            }
            if (common.getCookie('isVisit') !== 'true') {
              addRecord(params).then(res => {
                if (res.data.resultCode === 0) {
                  common.setCookie('isVisit', 'true')
                }
              })
            }
            document.title = info.data.resultData.chindleShortName
            let link = document.querySelector('link[rel*="icon"]') || document.createElement('link')
            link.type = 'image/x-icon'
            link.rel = 'shortcut icon'
            link.href = info.data.resultData.logoBrowser
            document.getElementsByTagName('head')[0].appendChild(link)
          }
          next()
        })
      }
    } else {
      next()
    }
  }
})
router.afterEach(() => {
  NProgress.done() // 结束Progress
})
/* eslint-disable no-new */
// 使用ElementUi
// Vue.use(ElementUI)
new Vue({
  el: '#app',
  router,
  store,
  common,
  auth,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js